"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withProviders = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var fos_ui_1 = require("@ntet/fos-ui");
var react_router_dom_1 = require("react-router-dom");
var styled_components_1 = require("styled-components");
var history_1 = require("history");
var AuthContext_1 = require("./auth/AuthContext");
var config_1 = require("./config");
var SessionTimeoutComponent_1 = (0, tslib_1.__importDefault)(require("./components/SessionTimeoutComponent"));
var OktaRoutes_1 = (0, tslib_1.__importDefault)(require("./auth/OktaRoutes"));
var history = (0, history_1.createBrowserHistory)();
var withProviders = function (WrappedComponent, customHistory) {
    var Wrapper = function (_a) {
        var ntConfig = _a.ntConfig;
        return (react_1.default.createElement(config_1.NTConfigProvider, { ntConfig: ntConfig },
            react_1.default.createElement(styled_components_1.ThemeProvider, { theme: fos_ui_1.theme },
                react_1.default.createElement(react_router_dom_1.Router, { history: customHistory !== null && customHistory !== void 0 ? customHistory : history },
                    react_1.default.createElement(AuthContext_1.AuthProvider, null,
                        react_1.default.createElement(SessionTimeoutComponent_1.default, { history: history }),
                        react_1.default.createElement(OktaRoutes_1.default, null,
                            react_1.default.createElement(WrappedComponent, { ntConfig: ntConfig })))))));
    };
    return Wrapper;
};
exports.withProviders = withProviders;
